<label
  class="icp-checkbox"
  [class.checked]="checked"
  [class.disabled]="disabled"
  [attr.for]="id"
  (click)="toggle()"
>
  <span class="checkbox-icon">
    <icp-icon
      *ngIf="checked"
      name="checkbox-checked"
      [size]="17"
    ></icp-icon>
    <icp-icon
      *ngIf="!checked"
      name="checkbox"
      [size]="17"
    ></icp-icon>
  </span>
  <span class="checkbox-label" *ngIf="label">{{ label }}</span>
</label>

